$(document).ready(function () {

 window.alert = function(){
   console.log("alert")
 }
  
/* setTimeout(function(){
 let shippingItem = document.querySelector(".deliv-img-container")
 let isAccessories = document.getElementById("cross-sells")
console.log(isAccessories)
 if(isAccessories == undefined){
   shippingItem.style.display = "none"
 } 
}, 3000)
*/

   if($("body").hasClass("template-product")){
    let doc = document.referrer
    console.log(doc)
    console.log("BODIED")
        if (doc.includes("collection")) {
    console.log("The main string contains the substring.");
          $("#bck-to-collection").css("display","block")
     }
    else{
      $("#bck-to-collection").css("display","none")
    }
  }

  $("#bck-to-collection").click(function(){
    
    console.log("next_prev_groups")
    window.history.back();
  })

  
  $(".url_helper [href]").each(function () {
    // adds color to active nav-item
    var base_url = "https://koot.com";
    var res_url = base_url.concat(location.pathname);

    if (this.href == res_url) {
      $(this).addClass("active_url");
    }

    // changing filter dropdown on collection page
    $(".d-noner").first().css("display", "block");
    var featuredFilter = $("#tab-featured").width();
    featuredFilter = featuredFilter + 9;
    $(".dropdown-menu").width(featuredFilter);
  });

  // hides promotion bar when popup cart is shown
  $(".new__add-to-cart").click(function () {
    $("#spb-information-bar").css("display", "none");
      $(".loading-modal").show();
  });
  
 

  // hides delivery app depending on whether product is in stock, click is called in a.delivery snippet
  $(".price__gallery").click(function () {
    setTimeout(function(){
    var restyy = $(".trustblox-1-timer-wrap").get();
    restyy = restyy[0];
    $(restyy).css("display", "none");
   // $(restyy).remove();
 
    console.log("this is price gallery")
    },3000)
  }); 

 $(".close-cart").click(function(){
   $("html").removeClass("cart-show")
 })

  $(".acc-mb").click(function(){
    $("html").addClass("customer-show")
  })

   $(".close-customer").click(function(){
   $("html").removeClass("customer-show")
 })

  
  
   
     
     $(".swatch-element").each(function(){
      var len = document.getElementsByClassName("swatch-element").length;
       if(len > 6 && $(window).width() > 740){
         $(".product-img-box").css({"position":"sticky","top":"60px","align-self":"auto","margin-bottom":"200px"})
         $("html").css("overflow-x","visible");
       }
      
     })     

  $("#mobile-appear").click(function () {
    $(".sidebar").css({
      transform: "translateX(-0%)",
      "webkit-transform": "translateX(-0%)",
    });
    $(".closerr").css("opacity", "1");
    var elon = $("#tab-featured").width();
  });

  $("#close-mobile").click(function () {
    $(".sidebar").css({
      transform: "translateX(-100%)",
      "webkit-transform": "translateX(-100%)",
    });
    $(".closerr").css("opacity", "0");
  });

  $(".product-js-title").click(function () {
    $(".product-js-title").removeClass("pj");
    $(this).addClass("pj");
  });

  // hides promotion app when mobile menu opened
  $(".icon-nav").click(function () {
    $(".icon-nav").toggleClass("close");
    $("#spb-information-bar").css("display", "none");
    $("body").css("padding-top", "0px");
   // $(".wrapper-pop-up").toggleClass("opened");
  });

  $("#myBtn").click(function () {
   // $(".wrapper-pop-up").toggleClass("opened");
  });

  $("#tab-featured").click(function () {
    $("#tab-featured .icon-dropdown").toggleClass("open");
  });

  $("#tab-featured .dropdown-menu li").click(function () {
    $("#tab-featured .icon-dropdown").toggleClass("open");
  });

  $(window).click(function () {
    if ($("#tab-featured .icon-dropdown").hasClass("open")) {
      $("#tab-featured .icon-dropdown").toggleClass("open");
    }
  });

  $(".close-search").click(function () {
    $("html").removeClass("search-open");

    $(".quickSearchResultsWrap").hide();
  });

  $(".wishlist-close").click(function () {
    $(".wrapper-pop-up").removeClass("opened");

    $("#myModal").css("display", "none");
  });

  $(".wishlist").click(function () {
    setTimeout(function () {
      var wishlist_icon = $(".wishlist").hasClass("test-class");

      var x = $(".wishlist-2").find(".cls-1");
    }, 3000);
  });

  $(".comp-link").click(function(){
    console.log("comp-link")
  })

  $(".price-regular span").click(function (e) {
    e.preventDefault();
    var prodRes = $(".product-title").text();
  });
  /*  $(".product-top").hover(function(){
      console.log("product-top")
    var swtches = $(this).parent().next()
    var resswatches = swtches.get();
    var resArr = resswatches[0]  
    $(resArr).css("display","block")
    
    }, function(){
      console.log("product-top-off")
       var swtches = $(this).parent().next()
    var resswatches = swtches.get();
    var resArr = resswatches[0] 
     $(resArr).css("display","none")
    }); */

  $(".product-item").hover(
    function (e) {
      var q = $(this).find(".swatches");

      var qres = q[0];
      $(qres).css("display", "block");

      //  $('.star-set-image').css({"width":"40px","height":"40px"})
    },
    function () {
      var q = $(this).find(".swatches");

      var qres = q[0];
      $(qres).css("display", "none");
    }
  );

  var prodTitles = $(".product-bottom .product-title span");

  $(prodTitles).each(function () {
    var yoooo = $(".prod-fix-title").height();
    var oneParent = $(this).parents(".prod-fix-title").height();

    var prodTitle = this;

    var res = $(prodTitle).text();
    var lengthkeep = res.length;
    var newres = res.split("");

    newres.pop();
    var musk = newres.join(" ");
    var musklength = musk.length;

    if (oneParent == 23 && $(window).width() > 760) {
      $(prodTitle).parent().css("margin-bottom", "26px");
    }
  });

  setTimeout(function () {
    var appProdTitles = $(".producttitle a");

    $(appProdTitles).each(function () {
      var height = $(this).height();

      if (height == 40) {
        var roar = $(this).find(".money").css("margin-top", "16px");
      }
    });
  }, 10000);

/*  $(".swatch-element").hover(
    function () {
      $(this).css("background-color", "rgba(0,0,0,0.20)");
    },
    function () {
      if ($(this).css("background-color", "rgba(0,0,0,0.20)")) {
        $(this).css("background-color", "rgba(0,0,0,0.02)");
      }
    }
  ); */
  
  

  $(".swatch-element").click(function(){
   
    $(".swatch-element").css("background-color", "rgba(0,0,0,0.02)")
    var activeVariant = $(this).get();
    activeVariant = activeVariant[0];
    $(activeVariant).css("background-color", "rgba(0,0,0,0.20)")

     var hasinventory = $(this).data("inventory")

    console.log("this is data" + hasinventory)

    if(hasinventory > 0){
      console.log("hasInventory")
      $(".voorad").css("display","block") 
     setTimeout(function(){
    var restyy = $(".trustblox-1-timer-wrap").get();
    restyy = restyy[0];
   $(restyy).css("display", "none");
     },3000) 
    
    }
    else{
      console.log("hasNOTInventory")
     setTimeout(function(){
    var restyy = $(".trustblox-1-timer-wrap").get();
    restyy = restyy[0];
   $(restyy).css("display", "block");
     },3000)  
    $(".voorad").css("display","none") 
  
    }
   
    
  });

  $(".swatch-element").each(function () {});

  $(".product__section-title").click(function () {
    if ($(window).width() < 701) {
      $(".prod_unicode").toggleClass("active-unicode");
      $(".list-container").toggleClass("active-accord");
      $(".collapsible-toggle").toggleClass("d-block")
    }
  });

  $(".desc").click(function () {
    if ($(window).width() < 701) {
      $(".desc").toggleClass("active-unicode");
      $(".desc-answers").toggleClass("active-accord");
    }
  });
  
  $(".collapsible-toggle").click(function(){
    $(".collapsible-content").toggleClass("collapsible-block");
     let less =  $(this).data("less")
     let more =  $(this).data("more")
    if($(".collapsible-content").hasClass("collapsible-block")){
   
     $(".collapsible-toggle").text(less)
    }
    else{
       $(".collapsible-toggle").text(more)
    }
  })

  /* var product__title = document.getElementsByClassName("product-js-title");
    
  var product__content = document.getElementById("product__content").innerText;
   var newArray = product__content.split(" ");
   newArray.pop(); 
   var res = newArray.join(" "); 
  
    
   // document.getElementById("product-js-title").innerHTML = res;
    for(i = 0;i<product__title.length;i++){
    
    var answer1 = product__title[i].getAttribute('data-newtitle')
      var res1 = res.concat('/',answer1) 
    product__title[i].innerText = res1;
    res1 = '';
    
    } */

  $(".collection-slider")
    .not(".slick-initialized")
    .slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 7000,
      speed: 1000,
      arrows: true,
      prevArrow:
        '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
      nextArrow:
        '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
      dots: false,

      responsive: [
        {
          breakpoint: 1199,
          settings: {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 7000,
            speed: 1000,
            arrows: true,
            dots: false,
            nextArrow:
              '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
            prevArrow:
              '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
          }
        },
          {
          breakpoint: 800,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 7000,
            speed: 1000,
            arrows: true,
            dots: false,
            nextArrow:
              '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
            prevArrow:
              '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
          }
        }
      ]
    });

  $(".collection-slider1")
    .not(".slick-initialized")
    .slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 7000,
      speed: 1000,
      arrows: true,
      prevArrow:
        '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
      nextArrow:
        '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
      dots: false,

      responsive: [
        {
           breakpoint: 1199,
          settings: {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 7000,
            speed: 1000,
            arrows: true,
            dots: false,
            nextArrow:
              '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
            prevArrow:
              '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
          }
        },
        {
          breakpoint: 800,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 7000,
            speed: 1000,
            arrows: true,
            dots: false,
            nextArrow:
              '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
            prevArrow:
              '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
          }
        
        }
      ]
    }); 

  $(".collection-slider2").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 1000,
    arrows: true,
    prevArrow:
      '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
    nextArrow:
      '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          variableWidth: true,
          autoplaySpeed: 7000,
          speed: 1000,
          arrows: true,
          dots: false,
          nextArrow:
            '<svg class = "slider-left" aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
          prevArrow:
            '<svg class = "slider-svg" aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
        },
      },
    ],
  });

  $(".collection-slider2").on(
    "afterChange",
    function (event, slick, currentSlide) {
      var prodTitles = $(".product-bottom .product-title span");

      $(prodTitles).each(function () {
        var yoooo = $(".prod-fix-title").height();
        var oneParent = $(this).parents(".prod-fix-title").height();

        var prodTitle = this;

        var res = $(prodTitle).text();
        var lengthkeep = res.length;
        var newres = res.split("");

        newres.pop();
        var musk = newres.join(" ");
        var musklength = musk.length;

        if (oneParent == 23 && $(window).width() > 760) {
          $(prodTitle).parent().css("margin-bottom", "26px");
        }
      });
    }
  );

  $(".collection-slider1").on(
    "afterChange",
    function (event, slick, currentSlide) {
      var prodTitles = $(".product-bottom .product-title span");

      $(prodTitles).each(function () {
        var yoooo = $(".prod-fix-title").height();
        var oneParent = $(this).parents(".prod-fix-title").height();

        var prodTitle = this;
        var res = $(prodTitle).text();
        var lengthkeep = res.length;
        var newres = res.split("");

        newres.pop();
        var musk = newres.join(" ");
        var musklength = musk.length;

        if (oneParent == 23 && $(window).width() > 760) {
          $(prodTitle).parent().css("margin-bottom", "26px");
        }
      });
    }
  );

  $(".collection-slider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      var prodTitles = $(".product-bottom .product-title span");

      $(prodTitles).each(function () {
        var yoooo = $(".prod-fix-title").height();
        var oneParent = $(this).parents(".prod-fix-title").height();

        var prodTitle = this;
        var res = $(prodTitle).text();
        var lengthkeep = res.length;
        var newres = res.split("");

        newres.pop();
        var musk = newres.join(" ");
        var musklength = musk.length;

        if (oneParent == 23 && $(window).width() > 760) {
          $(prodTitle).parent().css("margin-bottom", "26px");
        }
      });
    }
  );
});
